module.exports = __webpack_public_path__ + "static/media/modelo_3.ade16cb5.svg";